import React from 'react';
import getConfig from 'next/config';
import BasicLayout from 'layout/Basic';
import { convertProps } from 'lib/parseAPIResponse';
import TagsPage, { Props } from 'containers/Tags';

export const SubCategory = (props: Props) => {
    return (
        <BasicLayout ads={props.ads}>
            <TagsPage {...props} />
        </BasicLayout>
    );
};

export async function getServerSideProps({ params, query }) {
    const slug = params.slug as string;
    const page = query.page || 1;

    const { apiUrl } = getConfig().publicRuntimeConfig;
    return Promise.all([
        fetch(`${apiUrl}/public/api/tags/${slug},${page}`),
        fetch(`${apiUrl}/public/api/naszadsik?path=tagi`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
}

export default SubCategory;
